module.exports = __webpack_public_path__ + "static/img/zkhz_banner_shouyijixujiaoyu.4ed38d83.png";